import { render, staticRenderFns } from "./ZupanijaBase.vue?vue&type=template&id=16f54aa4&scoped=true&"
import script from "./ZupanijaBase.vue?vue&type=script&lang=js&"
export * from "./ZupanijaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f54aa4",
  null
  
)

export default component.exports